import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import * as moment from 'moment'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()
const movimientos = {
  1: 'Altas pendientes',
  2: 'Bajas pendientes',
  3: 'Modificaciones pendientes',
}

export class FanProyectoColaboradoresIDSEExportarComponent {
  proyectoId
  tipoMovimientoId
  fechaInicial
  fechaFinal
  clase
  onClose
  filtro = ''
  promise = null
  data = null
  resultados = null
  ultimo = null
  clases = []
  movimientos = movimientos
  todosSeleccionados = true

  constructor ($location, $q, $state, FanProyectoColaboradoresIDSEMovimientosService, FanProyectoColaboradoresIDSEClases) {
    this.$location = $location
    this.$q = $q
    this.$state = $state
    this.FanProyectoColaboradoresIDSEMovimientosService = FanProyectoColaboradoresIDSEMovimientosService
    this.FanProyectoColaboradoresIDSEClases = FanProyectoColaboradoresIDSEClases
  }

  $onInit () {
    this.promise = this.$q.all([
      this.FanProyectoColaboradoresIDSEClases.get(this.proyectoId)
        .then(({data}) => (this.clases = data)),
      this.obtenerMovimientos(),
    ])
  }

  buscar () {
    this.$location.replace()
    this.$location.search({
      clase: this.clase,
      fecha_inicial: this.fechaInicial ? moment(this.fechaInicial).format('YYYY-MM-DD') : undefined,
      fecha_final: this.fechaFinal ? moment(this.fechaFinal).format('YYYY-MM-DD') : undefined,
    })

    return this.obtenerMovimientos()
  }

  obtenerMovimientos () {
    if (!this.clase) return

    return this.FanProyectoColaboradoresIDSEMovimientosService.get(this.proyectoId, this.tipoMovimientoId, this.clase, this.fechaInicial, this.fechaFinal)
      .then(({data}) => {
        this.data = orderBy(data.resultados, ['fecha', 'colaborador'], ['desc', 'asc'])
        this.data.forEach((item) => {
          item.agrupacion = moment(item.fecha).format('LL')
          item.seleccionado = true
          item.busqueda = normalizar(`${item.colaborador}|${item.imss}`)
        })

        this.resultados = [...this.data]
        this.seleccionados = [...this.data]
        this.todosSeleccionados = !!this.seleccionados.length
      })
  }

  seleccionarTodos () {
    this.todosSeleccionados = !this.todosSeleccionados
    this.resultados.forEach((item) => (item.seleccionado = this.todosSeleccionados))
    this.filtrarSeleccionados()
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => normalizar(item.busqueda).indexOf(filtro) >= 0)
    this.todosSeleccionados = this.resultados.every((item) => item.seleccionado)
  }

  descargar () {
    this.confirmar = true
  }

  filtrarSeleccionados () {
    this.seleccionados = this.data.filter((item => item.seleccionado))
  }

  cerrar ({generado}) {
    this.confirmar = false
    if (generado) {
      this.$state.go('proyecto.colaboradores.idse')
    }
  }
}

module.component('fanProyectoColaboradoresIdseExportar', {
  controller: FanProyectoColaboradoresIDSEExportarComponent,
  template,
  bindings: {
    proyectoId: '<',
    tipoMovimientoId: '<',
    fechaInicial: '<',
    fechaFinal: '<',
    clase: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/idse/exportar/component.js